'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapWithTransform = exports.expandSubProps = exports.expandMainProp = exports.toAppendedProps = undefined;

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _config = require('./config');

var toAppendedProps = exports.toAppendedProps = function toAppendedProps(propName, style, affixedValues, toProp) {
  return (0, _ramda.reduce)(function (acc, direction) {
    return (0, _ramda.compose)((0, _ramda.assoc)(_ramda.__, style, acc), toProp, _ramdaAdjunct.list)(propName, direction);
  }, {}, affixedValues);
};

var expandMainProp = exports.expandMainProp = function expandMainProp(propName, style) {
  var wrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ramda.identity;
  return (0, _ramda.assoc)(propName, (0, _ramda.over)(_config.lTransformers, wrapper, style));
};

var expandSubProps = exports.expandSubProps = function expandSubProps(toProp, suffixes) {
  var wrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ramda.identity;
  return function (propName, style) {
    return (0, _ramda.mergeDeepRight)(toAppendedProps(propName, (0, _ramda.over)(_config.lTransformers, wrapper, style), suffixes, toProp));
  };
};

var wrapWithTransform = exports.wrapWithTransform = function wrapWithTransform(wrapper) {
  return function (propName, style) {
    return (0, _ramda.pipe)((0, _ramda.over)(_config.lTransformers, wrapper), (0, _ramda.objOf)(propName))(style);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/expanders.js
// module id = 84
// module chunks = 168707334958949